import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/editorProfiles",
        name: "EditorProfiles",
        component: () => import("@/components/editorProfiles/_EditorProfiles.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.GetEditorProfiles,
            breadcrumbs: {
                icon: "editor-profiles-icon",
                paths: []
            },
            title: "navbar.editorProfiles"
        }
    },
    {
        path: "/editorProfiles/create",
        name: "EditorProfileForm",
        component: () => import("@/components/editorProfiles/_EditorProfileForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateEditorProfile,
            breadcrumbs: {
                icon: "editor-profiles-icon",
                paths: [
                    ["/editorProfiles", i18n.t("editorProfiles.title")]
                ]
            },
            title: "editorProfiles.createTitle"
        },
        props: true
    },
    {
        path: "/editorProfiles/update/:editorProfileId",
        name: "EditorProfileFormUpdate",
        component: () => import("@/components/editorProfiles/_EditorProfileForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateEditorProfile,
            breadcrumbs: {
                icon: "editor-profiles-icon",
                paths: [
                    ["/editorProfiles", i18n.t("editorProfiles.title")]
                ]
            }
        },
        props: true
    }
];
